import "../styles/Treks.css";
// import { useState } from "react";
// import TrekForm from './TrekForm.js';

const SatopanthTrek = () => {
  // const images = [
  //   "./Satopanth/IMG1.jpg",
  //   "./Satopanth/IMG2.jpg",
  //   "./Satopanth/IMG3.jpg",
  //   "./Satopanth/IMG4.jpg",
  //   "./Satopanth/IMG5.jpg"
  // ];

  // const [confirm, setConfirm] = useState(false);

  //  useEffect(() => {
  //     window.scrollTo({top : 0, behavior : "smooth"})  
  //   }, [])

  return (
    // <div className="trek-container">
    //   <header className="trek-header">
    //     <img src="./Satopanth/banner.jpg" alt="Satopanth Tal" className="trek-banner"/>
    //     <h1 className="trek-title">Satopanth Tal Trek</h1>
    //   </header>

    //   <main className="trek-main">
    //     <section className="trek-section">
    //       <h2>Trek Overview</h2>
    //       <p>
    //         Region : Garhwal Himalayas, Uttarakhand<br/>
    //         Altitude : 4,600 meters (15,100 feet)<br/>
    //         Duration : 5 Days / 4 Nights<br/>
    //         Distance : 50 km approx.<br/>
    //         Difficulty : Moderate to Challenging<br/>
    //         Starting Point : Badrinath<br/>
    //         Ending Point : Badrinath<br/>
    //         Cost: <strong>INR 22,999 per person (incl. meals + camping)</strong><br/>
    //         Best Season : May to October
    //       </p>
    //     </section>

    //     <div className="btn-container">
    //       <button className="butn">Coming Soon</button>
    //     </div>

    //     <section className="trek-gallery">
    //       {images.map((img, i) => (
    //         <img key={i} src={img} alt="Satopanth View" className="gallery-img"/>
    //       ))}
    //     </section>

    //     {[
    //       {
    //         title: "Day-wise Itinerary",
    //         content: [
    //           "Day 1 : Arrival in Badrinath – Acclimatization – Local sightseeing",
    //           "Day 2 : Trek to Lakshmi Van – 9 km – Campsite setup",
    //           "Day 3 : Trek to Chakratirth – 10 km – Stunning alpine views",
    //           "Day 4 : Trek to Satopanth Tal and return to Chakratirth",
    //           "Day 5 : Trek back to Badrinath – Departure"
    //         ],
    //       },
    //       {
    //         title: "Preparation for Trek",
    //         content: [
    //           "High-altitude endurance training",
    //           "Essential documents & permits",
    //           "Camping essentials – tents, sleeping bags",
    //           "Experienced guide is mandatory"
    //         ],
    //       },
    //       {
    //         title: "Highlights",
    //         content: [
    //           "Mythical Satopanth Tal – believed to be visited by the Trimurtis",
    //           "Views of Chaukhamba, Neelkanth & Balakun peaks",
    //           "Remote and peaceful glacial trails",
    //           "Sacred and spiritual journey"
    //         ],
    //       },
    //       {
    //         title: "What to Carry",
    //         content: [
    //           "Sturdy trekking boots & thermals",
    //           "Backpack, dry snacks, water bottles",
    //           "Sunscreen, sunglasses, and lip balm",
    //           "Torch, raincoat, and power bank"
    //         ],
    //       },
    //       {
    //         title: "Tips from Guide",
    //         content: [
    //           "Start early to avoid afternoon winds",
    //           "Respect the silence and sacredness of the trail",
    //           "Always trek with a guide or local support",
    //           "Carry cash as ATMs are unreliable"
    //         ],
    //       }
    //     ].map((section, i) => (
    //       <section className="trek-section" key={i}>
    //         <h2>{section.title}</h2>
    //         <ul>
    //           {section.content.map((line, j) => (
    //             <li key={j}>{line}</li>
    //           ))}
    //         </ul>
    //       </section>
    //     ))}

    //     <div className="btn-container">
    //       <button className="butn">Coming Soon</button>
    //     </div>
    //   </main>

    //   <footer className="trek-footer">
    //     <p>Note: For any queries regarding the trek, you can contact</p>
    //     <p>📞 +91 94589 27294 | | 📞 +91 82734 83585</p>
    //     © {new Date().getFullYear()} Satopanth Trek Experience
    //     <h3>Regards</h3> <strong>HOTEL SHYAM PALACE GHANGRIA</strong>
    //   </footer>

    //   {confirm && <TrekForm title="SATOPANTH TAL" onClose={() => setConfirm(false)} />}
    // </div>
    <div className="trek-container">
    <header className="trek-header">
    <h1 style={{color : '#2D6A4F'}}>Satopanth Tal Trek</h1>
    <h1 style={{color : '#2D6A4F'}}>Coming Soon</h1>
    </header>
    </div>
  );
};

export default SatopanthTrek;
